export default __webpack_public_path__ + "static/media/LOGO_ONBOARD_MOBILITY_SMALL_WHITE.174e4fc5.svg";